import styles from './ChangeAnalysisPage.module.scss';
import React, {useEffect, useMemo, useState} from 'react';
import {subsManager} from "../../../../store/middleware/subs-manager/subs-manager";
import {useActiveProjectSelector, useProjectVersionsSelector} from "../../../../store/selectors/project.selectors";
import {generateVersionDAGData} from "../../../../utils/version-control/generateVersionDAGData";
import VersionChart from "./components/VersionChart";
import {calculateChangeToTasks} from "../../../../utils/version-control/calculateChangeToTasks";
import {useAllTaskListSelector} from "../../../../store/selectors/task/task.selectors";
// import VersionChart from "./components/VersionChart";


export default function ChangeAnalysisPage() {
    const [baselineDetails, setBaselineDetails] = useState<any>(null);
    const [comparatorDetails, setComparatorDetails] = useState<any>(null);
    const activeProject = useActiveProjectSelector();
    const projectVersions = useProjectVersionsSelector();
    const [changeData, setChangeData] = useState<any>(null);
    const allTasks = useAllTaskListSelector();

    useEffect(() => {
        if (activeProject) subsManager.subscribeProjectVersions(activeProject.contractId, activeProject.projectId);
    }, [activeProject]);

    useEffect(() => {
        if (projectVersions.length > 0 && !changeData) {
            const newProject = projectVersions[projectVersions.length - 1]
            const oldProject = projectVersions[0]

            setChangeData(calculateChangeToTasks(newProject.projectId, newProject.dataVersionId, oldProject.projectId, oldProject.dataVersionId, allTasks));
        }
    }, [projectVersions]);

    // const dataVersions = useMemo(() => {
    //     if (projectVersions) {
    //         return generateVersionDAGData(projectVersions);
    //     } else {
    //         return [];
    //     }
    // }, [projectVersions]);

    return (
        <div className={styles.ChangeAnalysisPage}>
            <div className={styles.BaselineSelector}>
                {projectVersions.length > 0 &&
                    <VersionChart
                        width={window.innerWidth}
                        height={90}
                        chartData={projectVersions}
                        baseline={baselineDetails}
                        comparator={comparatorDetails}
                        setBaseline={setBaselineDetails}
                        setComparator={setComparatorDetails}
                    />}
            </div>
            <div className={styles.ComparatorSelector}>
            </div>
            <div className={styles.AnalysisResults}>
            </div>
        </div>
    )
}